<template>
    <svg class='svg svg--nav svg--nav--diamond-large' width='52' height='51' viewBox='0 0 52 51' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <line x1='26' y1='0' x2='26' y2='51' class='svg--nav__stroke' stroke-width='0.5' vector-effect='non-scaling-stroke' />
        <path d='M8 25.5C14 25.5 26 8.50509 26 -2.24109e-06C26 8.49745 38 25.5 44 25.5C38 25.5 26 42.4949 26 51C26 42.5025 14 25.5 8 25.5Z' class='svg--nav__fill' />
    </svg>
</template>